import { ScheduledLessonFilters } from '../services/scheduledLessonsServices';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { getErrorMessage } from '@/utils/getErrorMessage';
import useInfiniteService from './useInfiniteService';
import { scheduledLessonsQueryKeys } from '../services/querykeys';
import useAuth from './useAuth';
import { isStudent } from '@/functions/auth';

type UseScheduledLessonsProps = ScheduledLessonFilters;

export default function useScheduledLessons({
  klassId,
}: UseScheduledLessonsProps) {
  const { user } = useAuth();
  const { queryKey, queryFn } = scheduledLessonsQueryKeys.list({
    klassId,
    isActive: isStudent(user?.userType) || undefined,
  })._ctx.infinity;

  const {
    results,
    isInitialLoading,
    isRefetching,
    isFetchingNextPage,
    isFetching,
    hasNextPage,
    fetchNextPage,
    error,
    invalidate,
    meta,
  } = useInfiniteService({
    queryKey,
    queryFn,
    keepPreviousData: true,
    enabled: !!klassId && !isNaN(klassId),
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const scheduledLessonsError = getErrorMessage(error);

  const hookReturn = {
    results,
    loading: isInitialLoading,
    refetching: isRefetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    queryKey,
    error: scheduledLessonsError,
    fetching: isFetching,
    invalidate,
    meta,
  };

  return hookReturn;
}
